import { Box } from '@mui/material';
import { ResponsiveContainer, LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Line } from 'recharts';
import { CustomTooltip } from './averageTenureHelpers';
import { AverageTenureChartType } from 'domain/shared/staffing';
import { Alert } from 'framework/ui/mui-builder';

const AverageTenureChart = ({
  data = [],
  isExpanded = false,
}: {
  data: AverageTenureChartType[];
  isExpanded?: boolean;
}) => {
  if (!data?.length) {
    return <Alert color="info">No data</Alert>;
  }

  return (
    <Box sx={{ height: 400 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={isExpanded ? data : data.slice(-12)}
          margin={{
            top: 25,
            bottom: 10,
            right: 7,
          }}
        >
          <CartesianGrid strokeDasharray="2 2" />
          <XAxis
            dataKey="endMonth"
            angle={-45}
            textAnchor="end"
            height={80}
            padding={{ left: 5, right: 5 }}
            tick={{ fontSize: 12 }}
            label={{
              value: isExpanded ? 'Month' : 'Month (last 12 months)',
              position: 'insideBottom',
              offset: 10,
              style: { textAnchor: 'middle' },
            }}
          />
          <YAxis
            tick={{ fontSize: 12 }}
            label={{
              value: 'Average Tenure (months)',
              angle: -90,
              offset: 10,
              position: 'insideLeft',
              style: { textAnchor: 'middle' },
            }}
          />
          <Tooltip content={<CustomTooltip />} />

          <Line
            type="monotone"
            dataKey="averageTenure"
            name="Average Tenure"
            stroke="var(--mui-palette-primary-main)"
            strokeWidth={3}
            dot={{ fill: 'var(--mui-palette-primary-main)', strokeWidth: 2, r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default AverageTenureChart;
